import { MdClose } from "react-icons/md";
import roadmap from "../../assets/img/roadmap.jpg";
import jsPDF from "jspdf";
import { FaDownload } from "react-icons/fa";

const RoadmapModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const roadmapImageUrl = roadmap;

  const handleDownload = async () => {
    try {
      const response = await fetch(roadmapImageUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.onload = () => {
        const imgData = reader.result;
        const img = new Image();
        img.onload = () => {
          const imgWidth = img.width;
          const imgHeight = img.height;

          // Determine orientation based on image aspect ratio
          const orientation = imgWidth > imgHeight ? "l" : "p"; // 'l' for landscape, 'p' for portrait
          const doc = new jsPDF(orientation, "pt", "a4");

          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();

          const aspectRatio = imgWidth / imgHeight;
          let finalWidth = pageWidth;
          let finalHeight = pageHeight;

          if (imgWidth > imgHeight) {
            // Landscape image
            finalHeight = pageWidth / aspectRatio;
            if (finalHeight > pageHeight) {
              // If height still too big for landscape A4
              finalHeight = pageHeight;
              finalWidth = pageHeight * aspectRatio;
            }
          } else {
            // Portrait image
            finalWidth = pageHeight * aspectRatio;
            if (finalWidth > pageWidth) {
              // If width still too big for portrait A4
              finalWidth = pageWidth;
              finalHeight = pageWidth / aspectRatio;
            }
          }

          // Center the image on the page
          const x = (pageWidth - finalWidth) / 2;
          const y = (pageHeight - finalHeight) / 2;

          doc.addImage(imgData, "JPEG", x, y, finalWidth, finalHeight);
          doc.save("Cephas-Kids-Tech-Roadmap.pdf");
        };
        img.src = imgData;
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Error downloading roadmap as PDF:", error);
      alert("Failed to download roadmap. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[95vh] overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-2xl font-bold text-[#113296]">
            Cephas Kids Tech Roadmap Preview
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <MdClose className="w-6 h-6" />
          </button>
        </div>
        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
          <div className="mb-6">
            <img
              src={roadmapImageUrl || "/placeholder.svg"}
              alt="Roadmap Preview"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
          {/* The text content below is kept for display, but the download button now downloads the image as PDF */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-[#113296]">
              Learning Path Overview
            </h3>
            <p className="text-gray-700 leading-relaxed">
              Our comprehensive roadmap guides students through four main
              learning tracks:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-semibold text-[#113296]">
                  Computer Literacy
                </h4>
                <p className="text-gray-700">₦100,000 - Foundation skills</p>
              </div>
              <div className="bg-orange-50 p-4 rounded-lg">
                <h4 className="font-semibold text-[#113296]">Product Design</h4>
                <p className="text-gray-700">
                  ₦140,000 - Creative design skills
                </p>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-semibold text-[#113296]">Programming</h4>
                <p className="text-gray-700">₦120,000 - Coding fundamentals</p>
              </div>
              <div className="bg-orange-50 p-4 rounded-lg">
                <h4 className="font-semibold text-[#113296]">
                  Automation & Robotics
                </h4>
                <p className="text-gray-700">₦300,000 - Advanced tech skills</p>
              </div>
            </div>
            <div className="bg-[#113296] text-white p-4 rounded-lg mt-6">
              <h4 className="font-semibold">Total Package: ₦600,000</h4>
              <p>Complete learning journey for ages 7-19</p>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className="flex justify-end gap-4 p-6 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Close
          </button>
          <button
            onClick={handleDownload}
            className="px-6 py-2 bg-[#FF4B01] text-white rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2"
          >
            <FaDownload className="w-4 h-4" />
            Download Roadmap
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoadmapModal;

// import { MdClose, MdDownload } from "react-icons/md";

// const RoadmapModal = ({ isOpen, onClose }) => {
//   if (!isOpen) return null;

//   const handleDownload = () => {
//     // Create a temporary roadmap content
//     const roadmapContent = `
// CEPHAS KIDS TECH ROADMAP

// Learning Tracks:

// 1. Computer Literacy - ₦100,000
//    - Understanding hardware and software components
//    - File management and internet safety
//    - Microsoft Office, Google Workspace
//    - Email skills and social media awareness

// 2. Product Design - ₦140,000
//    - Graphics design principles and tools
//    - UI/UX Design fundamentals
//    - User research and empathy mapping
//    - Wireframing and prototyping

// 3. Programming - ₦120,000
//    - Mobile App Development
//    - Web Design (HTML, CSS, JavaScript)
//    - Python programming fundamentals
//    - Data analysis basics

// 4. Automation & Robotics - ₦300,000
//    - IoT, Robotics, and Hardware Engineering
//    - Circuit Design and Microcontrollers
//    - Communication Protocols
//    - Advanced Robotics and Automation

// Total Package: ₦600,000
// Age Range: 7-19 years

// Contact: 07032490411, 08141335945
// Website: www.cephasict.com
//     `;

//     const blob = new Blob([roadmapContent], { type: "text/plain" });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "Cephas-Kids-General-Roadmap.txt";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-lg max-w-4xl w-full max-h-[95vh] overflow-hidden">
//         {/* Header */}
//         <div className="flex justify-between items-center p-6 border-b">
//           <h2 className="text-2xl font-bold text-[#113296]">
//             Cephas Kids Tech Roadmap Preview
//           </h2>
//           <button
//             onClick={onClose}
//             className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//           >
//             <MdClose className="w-6 h-6" />
//           </button>
//         </div>

//         {/* Content */}
//         <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
//           <div className="mb-6">
//             <img
//               src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Cephas%20Kids%20Roadmap.jpg-AwGNGmA5N6MOivyZynMnj3slKHHgoI.jpeg"
//               alt="Roadmap Preview"
//               className="w-full h-auto rounded-lg shadow-lg"
//             />
//           </div>

//           <div className="space-y-4">
//             <h3 className="text-xl font-semibold text-[#113296]">
//               Learning Path Overview
//             </h3>
//             <p className="text-gray-700 leading-relaxed">
//               Our comprehensive roadmap guides students through four main
//               learning tracks:
//             </p>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
//               <div className="bg-blue-50 p-4 rounded-lg">
//                 <h4 className="font-semibold text-[#113296]">
//                   Computer Literacy
//                 </h4>
//                 <p className="text-gray-700">₦100,000 - Foundation skills</p>
//               </div>
//               <div className="bg-orange-50 p-4 rounded-lg">
//                 <h4 className="font-semibold text-[#113296]">Product Design</h4>
//                 <p className="text-gray-700">
//                   ₦140,000 - Creative design skills
//                 </p>
//               </div>
//               <div className="bg-blue-50 p-4 rounded-lg">
//                 <h4 className="font-semibold text-[#113296]">Programming</h4>
//                 <p className="text-gray-700">₦120,000 - Coding fundamentals</p>
//               </div>
//               <div className="bg-orange-50 p-4 rounded-lg">
//                 <h4 className="font-semibold text-[#113296]">
//                   Automation & Robotics
//                 </h4>
//                 <p className="text-gray-700">₦300,000 - Advanced tech skills</p>
//               </div>
//             </div>

//             <div className="bg-[#113296] text-white p-4 rounded-lg mt-6">
//               <h4 className="font-semibold">Total Package: ₦600,000</h4>
//               <p>Complete learning journey for ages 7-19</p>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="flex justify-end gap-4 p-6 border-t bg-gray-50">
//           <button
//             onClick={onClose}
//             className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
//           >
//             Close
//           </button>
//           <button
//             onClick={handleDownload}
//             className="px-6 py-2 bg-[#FF4B01] text-white rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2"
//           >
//             <MdDownload className="w-4 h-4" />
//             Download Roadmap
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RoadmapModal;

// import { MdClose, MdDownload } from "react-icons/md";

// const RoadmapModal = ({ isOpen, onClose }) => {
//   if (!isOpen) return null;

//   const handleDownload = () => {
//     // Create a download link
//     const link = document.createElement("a");
//     link.href = "/roadmaps/cephas-kids-general-roadmap.pdf";
//     link.download = "Cephas-Kids-General-Roadmap.pdf";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
//         {/* Header */}
//         <div className="flex justify-between items-center p-6 border-b">
//           <h2 className="text-2xl font-bold text-[#113296]">
//             Cephas Kids Tech Roadmap Preview
//           </h2>
//           <button
//             onClick={onClose}
//             className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//           >
//             <MdClose className="w-6 h-6" />
//           </button>
//         </div>

//         {/* Content */}
//         <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
//           <div className="mb-6">
//             <img
//               src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Cephas%20Kids%20Roadmap.jpg-AwGNGmA5N6MOivyZynMnj3slKHHgoI.jpeg"
//               alt="Roadmap Preview"
//               className="w-full h-auto rounded-lg shadow-lg"
//             />
//           </div>

//           <div className="space-y-4">
//             <h3 className="text-xl font-semibold text-[#113296]">
//               Learning Path Overview
//             </h3>
//             <p className="text-gray-700 leading-relaxed">
//               Our comprehensive roadmap guides students through four main
//               learning tracks:
//             </p>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
//               <div className="bg-blue-50 p-4 rounded-lg">
//                 <h4 className="font-semibold text-[#113296]">
//                   Computer Literacy
//                 </h4>
//                 <p className="text-gray-700">₦100,000 - Foundation skills</p>
//               </div>
//               <div className="bg-orange-50 p-4 rounded-lg">
//                 <h4 className="font-semibold text-[#113296]">Product Design</h4>
//                 <p className="text-gray-700">
//                   ₦140,000 - Creative design skills
//                 </p>
//               </div>
//               <div className="bg-blue-50 p-4 rounded-lg">
//                 <h4 className="font-semibold text-[#113296]">Programming</h4>
//                 <p className="text-gray-700">₦120,000 - Coding fundamentals</p>
//               </div>
//               <div className="bg-orange-50 p-4 rounded-lg">
//                 <h4 className="font-semibold text-[#113296]">
//                   Automation & Robotics
//                 </h4>
//                 <p className="text-gray-700">₦300,000 - Advanced tech skills</p>
//               </div>
//             </div>

//             <div className="bg-[#113296] text-white p-4 rounded-lg mt-6">
//               <h4 className="font-semibold">Total Package: ₦600,000</h4>
//               <p>Complete learning journey for ages 7-19</p>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="flex justify-end gap-4 p-6 border-t bg-gray-50">
//           <button
//             onClick={onClose}
//             className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
//           >
//             Close
//           </button>
//           <button
//             onClick={handleDownload}
//             className="px-6 py-2 bg-[#FF4B01] text-white rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2"
//           >
//             <MdDownload className="w-4 h-4" />
//             Download Roadmap
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RoadmapModal;
